import React from 'react'
import PropTypes from 'prop-types'
import { EXPIRY_STATUS } from 'src/models/Item'

const ExpiryStatusImage = ({
  wrapperClassName = 'top-1 right-2 z-10',
  isAbsolute = true,
  textClassName,
  imageClassName = 'h-4 w-4',
  status
}) => {
  if (!status) return null

  return (
    <div className={`${isAbsolute ? 'absolute' : ''} ${wrapperClassName}`}>
      {status === '期限切れ' ? (
        <span className={textClassName}>期限切れ</span>
      ) : (
        EXPIRY_STATUS?.[status] && (
          <img className={imageClassName} src={EXPIRY_STATUS[status]} alt={status} />
        )
      )}
    </div>
  )
}

ExpiryStatusImage.propTypes = {
  wrapperClassName: PropTypes.string,
  isAbsolute: PropTypes.bool,
  textClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  status: PropTypes.oneOf(['red', 'yellow', 'blue', '期限切れ'])
}

export default ExpiryStatusImage
